import { useLayoutEffect } from "react";

const DEFAULT_PRIMARY = "#000000";
const DEFAULT_PRIMARY_TEXT = "#FFFFFF";

export default function useBrandColors(
  primaryColor?: string | null,
  primaryTextColor?: string | null,
) {
  useLayoutEffect(() => {
    const root = document.documentElement;

    root.style.setProperty("--brand-primary", primaryColor ?? DEFAULT_PRIMARY);
    root.style.setProperty(
      "--brand-primary-text",
      primaryTextColor ?? DEFAULT_PRIMARY_TEXT,
    );

    return () => {
      root.style.setProperty("--brand-primary", DEFAULT_PRIMARY);
      root.style.setProperty("--brand-primary-text", DEFAULT_PRIMARY_TEXT);
    };
  }, [primaryColor, primaryTextColor]);
}
